module.exports = __webpack_public_path__ + "img/traffic3.50a71b6a.png";